export default __webpack_public_path__ + "static/media/timer_pause.89a4d559.svg";